import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import {isMobile} from 'react-device-detect';
import { Footer } from "antd/lib/layout/layout";
import { Collapse } from "antd";
import { color } from "../../theme";
import "./FooterCommon.css";
const { Panel } = Collapse;

const FooterCommon = (props) => {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
 
  isMobile = width < 768 && isMobile;
  return (
    <Footer className="common-footer">
      <div className="container">
        <div className="mc_container_fluid mc_bg_footer mc_footer_spacer mc_font_define">
          <div className="mc_row">
            <div className="mc_container">
              <div className="mc_row">
                <div className="mc_col_full">
                  <div className="mc_s_m_l">
                    <ul>
                      <li className="fb">
                        <a
                          href="https://www.facebook.com/ManipalCignaHealthInsurance"
                          target="_blank" rel="noopener noreferrer"
                        >
                          facebook
                        </a>
                      </li>
                      <li className="insta">
                        <a
                          href="https://www.instagram.com/manipalcigna_healthinsurance"
                          target="_blank" rel="noopener noreferrer"
                        >
                          Instagram
                        </a>
                      </li>
                      <li className="twitter">
                        <a
                          href="https://twitter.com/ManipalCigna"
                          target="_blank" rel="noopener noreferrer"
                        >
                          Twitter
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mc_col_fixed">
                  <div className="mc_contact_container">
                    <div className="mc_w_c">
                      <h4 className="mc_h4">Contact Us</h4>
                      <p>Callers from India</p>
                      <p>Toll-free number</p>
                      <p>
                        <a href="tel:1800-102-4462">1800-102-4462</a>
                      </p>
                      <p className="mc_i_f_mt">Callers outside India</p>
                      <p>
                        <a href="tel:+91 22 4985 4100">+91 22 4985 4100</a>
                      </p>
                      <p>
                        (Call charges as per the caller's tariff plan will
                        apply)
                      </p>
                    </div>
                    <div className="mc_w_c mc_f_mt">
                      <h4 className="mc_h4">Email</h4>
                      <p>For any queries email us at</p>
                      <p>
                        <a href="mailto:customercare@manipalcigna.com">
                          customercare@manipalcigna.com
                        </a>
                      </p>
                      <p>and for any policy alterations email us at</p>
                      <p>
                        <a href="mailto:mychangerequest@manipalcigna.com">
                          mychangerequest@manipalcigna.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mc_col_fluid">
                  <div className="mc_row">
                    {isMobile ? (
                      <Collapse
                        accordion
                        expandIconPosition="right"
                        expandIcon={({ isActive }) =>
                          isActive ? (
                            <FontAwesomeIcon
                              icon={faAngleUp}
                              color={color.black}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faAngleDown}
                              color={color.black}
                            />
                          )
                        }
                        className="footer-mobile-accordian"
                      >
                        <Panel
                          header="Health Insurance Plans"
                          key="Health Insurance Plans"
                        >
                          <HealthInsurancePlans />
                        </Panel>
                        <Panel header="Website" key="Website">
                          <Website />
                        </Panel>
                        <Panel header="Services" key="Services">
                          <Services />
                        </Panel>
                        <Panel header="About Us" key="About Us">
                          <AboutUs />
                        </Panel>
                        <Panel header="Partner Sites" key="Partner Sites">
                          <PartnerSites />
                        </Panel>
                        <Panel header="Compliance" key="Compliance">
                          <Compliance />
                        </Panel>
                        <Panel header="Quick links" key="Quick links">
                          <QuickLinks />
                        </Panel>
                        <Panel header="Articles" key="Articles">
                          <Articles />
                        </Panel>
                      </Collapse>
                    ) : (
                      <>
                        <HealthInsurancePlans />
                        <Website />
                        <Services />
                        <AboutUs />
                        <PartnerSites />
                        <Compliance />
                        <QuickLinks />
                        <Articles />
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="mc_row">
                {isMobile ? (
                  <div className="mobile-know-more-wrapper">
                    <div className="mc_mob_accordian">
                      <div className="mc_f_logo">
                        <a href="https://www.manipalcigna.com/">Logo</a>
                      </div>
                    </div>
                    <Collapse
                      accordion
                      expandIconPosition="right"
                      expandIcon={({ isActive }) =>
                        isActive ? (
                          <FontAwesomeIcon
                            icon={faAngleUp}
                            color={color.black}
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faAngleDown}
                            color={color.black}
                          />
                        )
                      }
                      className="footer-mobile-accordian"
                    >
                      <Panel header="Know More" key="Know More">
                        <KnowMore />
                      </Panel>
                    </Collapse>
                  </div>
                ) : (
                  <KnowMore />
                )}

                <div className="mc_col_full">
                  <div className="mc_c_r_content">
                    <p>
                      © 2019 ManipalCigna Health Insurance Company Limited. All
                      rights reserved. Trade Name / Trade Logo belongs to MEMG
                      International India Private Limited and Cigna Intellectual
                      Property Inc and is being used by ManipalCigna Health
                      Insurance Company Limited under license. For more details
                      on risk factors, terms and conditions, please read the
                      sales brochure/ sales document available on our website
                      (Download section) before concluding a sale.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Footer>
  );
};

const KnowMore = () => {
  return (
    <div className="mc_col_full mob_e_a_b">
      <div className="mc_f_b_ic">
        <div className="mc_l_c_b">
          <p>
            For all Terms &amp; Conditions and Disclaimers, Please
            <a href="https://www.manipalcigna.com/disclaimer" target="_blank" rel="noopener noreferrer">
              click here
            </a>
          </p>
          <br />
          <br />
          <div className="beware-box">
            <p>
              <b className="mc_h4">
                BEWARE OF SPURIOUS PHONE CALLS AND FICTITIOUS OFFERS.
              </b>
              <br />
              Do not fall prey to unknown calls or messages promising benefits
              for porting your policy or offering attractive premium discounts
              for making payment to unidentified Bank A/cs.
              <br />
              IRDAI is not involved in activities like selling insurance
              policies, announcing bonus or investment of premiums
              <br />
              Public receiving such phone calls are requested to lodge a police
              complaint and report the incident to the Company
              <br />
            </p>
          </div>
          <br />
          <br />
          <p>
            This site best viewed using latest versions of Chrome, Firefox,
            Safari, Microsoft Internet Explorer(10+) or a equivalent browser
            with a screen resolution of 1024 * 768 or higher. If your browser is
            of older version, you may have trouble viewing few of the features
            on our website properly.
          </p>
        </div>
      </div>
    </div>
  );
};
const Articles = () => {
  return (
    <div className="mc_l_o_c">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Articles</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a href="https://www.manipalcigna.com/blog" target="_blank" rel="noopener noreferrer">
                Blogs
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/wellness/wellness-bites/family-health"
                target="_blank" rel="noopener noreferrer"
              >
                Family Health
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/wellness/wellness-bites/healthy-ageing"
                target="_blank" rel="noopener noreferrer"
              >
                Healthy Ageing
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/wellness/wellness-bites/caregiver-resources"
                target="_blank" rel="noopener noreferrer"
              >
                Caregiver Resources
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/wellness/wellness-bites/exercise-and-fitness"
                target="_blank" rel="noopener noreferrer"
              >
                Exercise and Fiteness
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const QuickLinks = () => {
  return (
    <div className="mc_l_o_c">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Quick links</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a
                href="https://www.manipalcigna.com/downloads/products"
                target="_blank" rel="noopener noreferrer"
              >
                Downloads
              </a>
            </li>

            <li>
              <a
                href="https://www.manipalcigna.com/faqs/products"
                target="_blank" rel="noopener noreferrer"
              >
                FAQs
              </a>
            </li>

            <li>
              <a
                href="https://www.manipalcigna.com/learn/glossary"
                target="_blank" rel="noopener noreferrer"
              >
                Glossary
              </a>
            </li>

            <li>
              <a
                href="https://www.manipalcigna.com/home#locator"
                target="_blank" rel="noopener noreferrer"
              >
                Hospital Locator
              </a>
            </li>

            <li>
              <a
                href="https://www.manipalcigna.com/dematerialisation-policy-documents"
                target="_blank" rel="noopener noreferrer"
              >
                Dematerialisation Policy Documents
              </a>
            </li>

            <li>
              <a href="https://www.manipalcigna.com/our-tpas" target="_blank" rel="noopener noreferrer">
                Our TPAs
              </a>
            </li>

            <li>
              <a
                href="https://buyonline.manipalcigna.com/buy-health-insurance/illustration"
                target="_blank" rel="noopener noreferrer"
              >
                Benefit Illustration
              </a>
            </li>

            <li>
              <a
                href="https://buyonline.manipalcigna.com/buy-health-insurance/vaccination"
                target="_blank" rel="noopener noreferrer"
              >
                Covid Vaccination details
              </a>
            </li>

            <li>
              <a
                href="https://buyonline.manipalcigna.com/buy-health-insurance/document-vault"
                target="_blank" rel="noopener noreferrer"
              >
                Document Vault
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const Compliance = () => {
  return (
    <div className="mc_l_o_c">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Compliance</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a
                href="https://www.irdai.gov.in/Defaulthome.aspx?page=H1"
                target="_blank" rel="noopener noreferrer"
              >
                IRDAI Website
              </a>
            </li>
            <li>
              <a
                href="http://www.nccptrai.gov.in/nccpregistry/How%20to%20Register%20Preference.pdf?reqtrack=tNlsmRJUGSqrYLkaPijKmrdIG"
                target="_blank" rel="noopener noreferrer"
              >
                Do No Call
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/grievance-redressal"
                target="_blank" rel="noopener noreferrer"
              >
                Grievance Redressal
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/products-withdrawn-or-modified"
                target="_blank" rel="noopener noreferrer"
              >
                Products Withdrawn
              </a>
            </li>
            <li>
              <a href="http://www.gicouncil.in" target="_blank" rel="noopener noreferrer">
                General Insurance Counsil
              </a>
            </li>

            <li>
              <a
                href="https://www.manipalcigna.com/documents/20124/338926/Corporate+Agents.pdf/8041b583-4f06-535c-5f67-c7b5cbcc7d19?t=1595587167119"
                target="_blank" rel="noopener noreferrer"
              >
                Corporate Agents
              </a>
            </li>
            <li>
              <a href="https://www.manipalcigna.com/uw-approach">
                Underwriting Approach
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/documents/20124/338926/Blacklisted+Agents.pdf/4182f0ab-279c-d6fc-3300-cc74a298f996?t=1595587160956"
                target="_blank" rel="noopener noreferrer"
              >
                Blacklisted Agents
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const PartnerSites = () => {
  return (
    <div className="mc_l_o_c mc_setFull">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Partner Sites</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a href="https://manipal.edu/mu.html" target="_blank" rel="noopener noreferrer">
                Manipal University
              </a>
            </li>
            <li>
              <a href="https://www.manipalhospitals.com" target="_blank" rel="noopener noreferrer">
                Manipal Hospitals
              </a>
            </li>
            <li>
              <a href="https://www.stempeutics.com" target="_blank" rel="noopener noreferrer">
                Stempeutics Research
              </a>
            </li>
            <li>
              <a href="https://www.manipalfoundation.in" target="_blank" rel="noopener noreferrer">
                Manipal Foundation
              </a>
            </li>
            <li>
              <a href="https://www.cigna.com" target="_blank" rel="noopener noreferrer">
                Cigna Corporation
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const AboutUs = () => {
  return (
    <div className="mc_l_o_c">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">About Us</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a
                href="https://www.manipalcigna.com/management-team"
                target="_blank" rel="noopener noreferrer"
              >
                Management Team
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/press-releases"
                target="_blank" rel="noopener noreferrer"
              >
                Press Release
              </a>
            </li>
            <li>
              <a href="https://www.manipalcigna.com/careers" target="_blank" rel="noopener noreferrer">
                Careers
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/key-persons"
                target="_blank" rel="noopener noreferrer"
              >
                Key Persons
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/board-members"
                target="_blank" rel="noopener noreferrer"
              >
                Board Members
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const Services = () => {
  return (
    <div className="mc_l_o_c">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Services</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a
                href="https://www.manipalcigna.com/service-request"
                target="_blank" rel="noopener noreferrer"
              >
                Service Request
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/service-tat"
                target="_blank" rel="noopener noreferrer"
              >
                Service Turn-around-Time
              </a>
            </li>
            <li>
              <a
                href="https://buyonline.manipalcigna.com/buy-health-insurance/makepayment"
                target="_blank" rel="noopener noreferrer"
              >
                Quick Payment
              </a>
            </li>
            <li>
              <a
                href="https://buyonline.manipalcigna.com/buy-health-insurance/renew"
                target="_blank" rel="noopener noreferrer"
              >
                Renew Now
              </a>
            </li>
            <li>
              <a href="https://www.manipalcigna.com/claims" target="_blank" rel="noopener noreferrer">
                Track Claim Application
              </a>
            </li>
            <li>
              <a href="https://www.manipalcigna.com/claims" target="_blank" rel="noopener noreferrer">
                Claim Process
              </a>
            </li>
            <li>
              <a
                href="https://buyonline.manipalcigna.com/buy-health-insurance/si-opt"
                target="_blank" rel="noopener noreferrer"
              >
                Recurring Payment Opt Out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const HealthInsurancePlans = () => {
  return (
    <div className="mc_l_o_c mc_setFull">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Health Insurance Plans</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/prohealth-insurance"
              >
                ManipalCigna ProHealth Prime
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/lifetime-health"
              >
                ManipalCigna Lifetime Health
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/hospitalisation-plan-ph"
              >
                ManipalCigna ProHealth Insurance
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/super-topup"
              >
                ManipalCigna Super Top&nbsp;Up
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/prohealth-select"
              >
                ManipalCigna ProHealth Select
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/daily-hospital-cash/prohealth-cash"
              >
                ManipalCigna ProHealth Cash
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/arogya-sanjeevani-policy"
              >
                Arogya Sanjeevani Policy, ManipalCigna
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/corona-rakshak-policy"
              >
                Corona Rakshak Policy, ManipalCigna
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/hospitalization-cover/corona-kavach-policy"
              >
                Corona Kavach Policy, ManipalCigna
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/critical-illness-cover/lifestyle-protection-critical-care"
              >
                ManipalCigna Lifestyle Protection - Critical Care
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/personal-accident-cover/lifestyle-protection-accident-care"
              >
                ManipalCigna Lifestyle Protection - Accident Care
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/personal-accident-cover/saral-suraksha-bima"
              >
                Saral Suraksha Bima, ManipalCigna
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/group-insurance/prohealth-group-insurance-policy"
              >
                ManipalCigna ProHealth Group Insurance Policy
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/group-insurance/lifestyle-protection-group-policy"
              >
                ManipalCigna Lifestyle Protection Group Policy
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/group-insurance/group-overseas-travel-insurance"
              >
                ManipalCigna Group Overseas Travel Insurance Policy
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/group-insurance/flexicare-group-insurance-policy"
              >
                ManipalCigna FlexiCare Group Insurance Policy
              </a>
            </li>

            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.manipalcigna.com/group-insurance/global-health-group-policy"
              >
                ManipalCigna Global Health Group Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const Website = () => {
  return (
    <div className="mc_l_o_c">
      <div className="mc_i_c_b">
        <h4 className="mc_h4 hide-mobile">Website</h4>
        <div className="mc_l_i_c_b">
          <ul>
            <li>
              <a
                href="https://www.manipalcigna.com/privacy-policy"
                target="_blank" rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/terms-and-conditions"
                target="_blank" rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
            </li>
            <li>
              <a
                href="https://www.customer.manipalcigna.com/user/login"
                target="_blank" rel="noopener noreferrer"
              >
                Customer Login
              </a>
            </li>
            <li>
              <a
                target="_blank" rel="noopener noreferrer"
                href="https://www.customer.manipalcigna.com/customer/register"
              >
                Register to Login
              </a>
            </li>
            <li>
              <a href="https://gohealthplus.manipalcigna.com/" target="_blank" rel="noopener noreferrer">
                Distributor Login
              </a>
            </li>
            <li>
              <a href="https://www.manipalcigna.com/disclaimer" target="_blank" rel="noopener noreferrer">
                Disclaimer
              </a>
            </li>
            <li>
              <a
                href="https://www.manipalcigna.com/disclosures/public-disclosures"
                target="_blank" rel="noopener noreferrer"
              >
                Disclosures
              </a>
            </li>

            <li>
              <a
                href="https://www.manipalcigna.com/disclosures/unclaimed-amount"
                target="_blank" rel="noopener noreferrer"
              >
                Unclaimed Amount
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FooterCommon;
